import { render } from "./ActivityUserIdentity.vue?vue&type=template&id=4a8c9f75&scoped=true"
import script from "./ActivityUserIdentity.vue?vue&type=script&lang=js"
export * from "./ActivityUserIdentity.vue?vue&type=script&lang=js"

import "./ActivityUserIdentity.vue?vue&type=style&index=0&id=4a8c9f75&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8c9f75"]])

export default __exports__